import { compact } from 'lodash';
import {
  clientNameColumn,
  programColumn,
  serviceTypeColumn,
  networkColumn,
} from '../baseColumns';
import {
  actionMenu,
  dateSent,
  lastUpdated,
  organization,
  recipient,
  status,
} from './columns';

export function acceptedClosedConfig(isSuperNetwork, showProgramNameColumn) {
  return compact([
    organization(),
    networkColumn(isSuperNetwork),
    clientNameColumn(),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name') : null,
    lastUpdated(),
  ]);
}

export function acceptedOpenConfig(isSuperNetwork, showProgramNameColumn) {
  return compact([
    organization(),
    networkColumn(isSuperNetwork),
    clientNameColumn(),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name') : null,
    lastUpdated(),
  ]);
}

export function allConfig(
  statuses = [],
  isSuperNetwork,
  currentSort,
  onSortColumn,
  showProgramNameColumn,
) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(currentSort, onSortColumn),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name', currentSort, onSortColumn) : null,
    status(statuses),
    lastUpdated(currentSort, onSortColumn),
  ]);
}

export function inReviewConfig(isSuperNetwork, showProgramNameColumn) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name') : null,
    lastUpdated(),
  ]);
}

export function needsActionConfig(isSuperNetwork, showProgramNameColumn) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name') : null,
    lastUpdated(),
  ]);
}

export function pendingConsentConfig(actions = [], isSuperNetwork, showProgramNameColumn) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    showProgramNameColumn ? programColumn('referred_to_program.name') : null,
    dateSent(),
    actionMenu(actions),
  ]);
}
